export type ValueOf<T> = T[keyof T];

export const SessionCdrState = Object.freeze({
  NotCreated: "NotCreated",
  Created: "Created",
  NotExpected: "NotExpected"
});

export type SessionCdrStateValues = ValueOf<typeof SessionCdrState>;
export type SessionCdrStateKeys = keyof typeof SessionCdrState;